import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBowling: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBowling"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Circle cx="16.25" cy="11.25" r="1.25" fill="currentColor"/><Circle cx="12" cy="12.25" r="1.25" fill="currentColor"/><Circle cx="13.1484" cy="8" r="1.25" fill="currentColor"/></CentralIconBase>;
});

export default IconBowling;
